import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
// Lazy load all route pages
const Home = lazy(() => import('./pages/Home').then(m => ({
  default: m.Home
})));
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const Services = lazy(() => import('./pages/Services').then(m => ({
  default: m.Services
})));
const Workshops = lazy(() => import('./pages/Workshops').then(m => ({
  default: m.Workshops
})));
const Talks = lazy(() => import('./pages/Talks').then(m => ({
  default: m.Talks
})));
const Courses = lazy(() => import('./pages/Courses').then(m => ({
  default: m.Courses
})));
const ConflictCoaching = lazy(() => import('./pages/courses/ConflictCoaching').then(m => ({
  default: m.ConflictCoaching
})));
const FirstTimeManager = lazy(() => import('./pages/courses/FirstTimeManager').then(m => ({
  default: m.FirstTimeManager
})));
const BetterOnlineMeetings = lazy(() => import('./pages/courses/BetterOnlineMeetings').then(m => ({
  default: m.BetterOnlineMeetings
})));
const BetterOnlineWorkshops = lazy(() => import('./pages/courses/BetterOnlineWorkshops').then(m => ({
  default: m.BetterOnlineWorkshops
})));
const ModernProductManagement = lazy(() => import('./pages/courses/ModernProductManagement').then(m => ({
  default: m.ModernProductManagement
})));
const Contact = lazy(() => import('./pages/Contact').then(m => ({
  default: m.Contact
})));
function LoadingFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0">
      <div className="w-8 h-8 border-3 border-teal border-t-transparent rounded-full animate-spin" data-id="element-1" />
    </div>;
}
function AnimatedRoutes() {
  return <Suspense fallback={<LoadingFallback data-id="element-3" />} data-id="element-2">
      <Routes data-id="element-4">
        <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
        <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
        <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
        <Route path="/services/workshops" element={<Workshops data-id="element-12" />} data-id="element-11" />
        <Route path="/services/talks" element={<Talks data-id="element-14" />} data-id="element-13" />
        <Route path="/services/courses" element={<Courses data-id="element-16" />} data-id="element-15" />
        <Route path="/services/courses/conflict-coaching" element={<ConflictCoaching data-id="element-18" />} data-id="element-17" />
        <Route path="/services/courses/first-time-manager" element={<FirstTimeManager data-id="element-20" />} data-id="element-19" />
        <Route path="/services/courses/better-online-meetings" element={<BetterOnlineMeetings data-id="element-22" />} data-id="element-21" />
        <Route path="/services/courses/better-online-workshops" element={<BetterOnlineWorkshops data-id="element-24" />} data-id="element-23" />
        <Route path="/services/courses/modern-product-management" element={<ModernProductManagement data-id="element-26" />} data-id="element-25" />
        <Route path="/contact" element={<Contact data-id="element-28" />} data-id="element-27" />
      </Routes>
    </Suspense>;
}
export function App() {
  return <Router data-id="element-29">
      <LanguageProvider data-id="element-30">
        <Layout data-id="element-31">
          <AnimatedRoutes data-id="element-32" />
        </Layout>
      </LanguageProvider>
    </Router>;
}